import { useQuery } from '@tanstack/react-query';

import { getSchoolDetail, getUserSchoolMembership, UserSchoolFilters } from '../../services/schools.service';

// Query keys factory
export const schoolsKeys = {
  all: ['schools'] as const,
  lists: () => [...schoolsKeys.all, 'list'] as const,
  list: (filters: UserSchoolFilters) => [...schoolsKeys.lists(), filters] as const,
  details: () => [...schoolsKeys.all, 'detail'] as const,
  detail: (id: number) => [...schoolsKeys.details(), id] as const,
};

// List query with filters and pagination

export function useUserSchoolMembership(
  filters: UserSchoolFilters,
) {
  return useQuery({
    queryKey: schoolsKeys.list(filters),
    queryFn: () => getUserSchoolMembership(filters),
    enabled: !!filters.baseuser, // run only when baseuser exists
    placeholderData: (previousData) => previousData,
  });
}
export function useSchoolDetails(school_id: string) {
  return useQuery({
    queryKey: schoolsKeys.detail(Number(school_id)),
    queryFn: () => getSchoolDetail(school_id),
    enabled: !!school_id,
  });
}
